<!-- <button *ngIf="!togglePromo" class="btn btn-ghost btn-block" (click)="togglePromo = !togglePromo">
  {{appCopy.panelHeader['titlePromocode'+selectedLanguage]}}
</button> -->
<!-- <div *ngIf="togglePromo">
</div> -->
  <form #formPromo="ngForm" name="formPromo"
    *ngIf="!price?.promoCodesApplied || price?.promoCodesApplied === null || price?.promoCodesApplied.length === 0" novalidate>
    <div class="row">
      <div class="col-xs-7 col-sm-8">
        <div class="form-group label-static margin-bottom-0">
          <input class="form-control" [ngClass]="{ 'has-error' : PromoCode?.errors?.pattern }" name="PromoCode"
            id="PromoCode" [(ngModel)]="userPromo" type="text" #PromoCode="ngModel" [pattern]="promoPattern" ngModel
            required appCheckEmpty>
          <label class="control-label" for="PromoCode">{{appCopy.panelHeader['promoCodeLabel'+selectedLanguage]}}</label>
          <p class="help-block margin-top-12 margin-bottom-0" *ngIf="!PromoCode?.errors?.pattern">
            {{appCopy.panelHeader['errorTextPromoCodeRequired'+selectedLanguage]}}</p>
          <p class="help-block text-danger margin-top-12 margin-bottom-0 " *ngIf="PromoCode?.errors?.pattern">
            {{appCopy.panelHeader['errorTextPromoCodeInvalid'+selectedLanguage]}}</p>
        </div>
      </div>
      <div class="col-xs-5 col-sm-4">
        <button id="promo-submit" type="button" class="btn btn-primary btn-block"
          (click)="checkPromoEvent(formPromo.value)" [disabled]="formPromo.invalid">
          <div class="loader-container-btn" *ngIf="showPromoLoader">
            <div class="loader loader--white">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
          <span *ngIf="!showPromoLoader">{{appCopy.panelHeader['buttonApply'+selectedLanguage]}}</span>
        </button>
      </div>
    </div>
  </form>

  <form #formPromoApplied="ngForm" *ngIf="price?.promoCodesApplied !== null">
    <div class="form-group margin-bottom-0" *ngFor="let code of price?.promoCodesApplied">
      <input class="form-control" id="PromoApplied" name="PromoApplied" type="text" [ngModel]='code' disabled
        appCheckEmpty required>
      <label class="control-label" for="PromoApplied">{{appCopy.panelHeader['promoCodeLabel'+selectedLanguage]}}</label>
      <div class="form-group--links">
        <a class="btn btn-link" href="javascript:void(0)" (click)="handleRemovePromo(code)"><i
            class="icon margin-right-8">cross</i>{{appCopy.panelHeader['buttonRemove'+selectedLanguage]}}</a>
      </div>
    </div>
  </form>
